/* eslint-disable import/prefer-default-export */
/**
 * Option identifiers for the HomeAutoRenewalDate field (ContentfulCampaignFormFieldOption)
 */
export enum HomeAutoRenewalDateOption {
  AUTO = 'AUTO',
  HOME = 'HOME',
  NEITHER = 'NEITHER',
}
